import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/sys/menu',
  owner: '/home',
  authority: 'menu',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};